import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'bra-input',
  templateUrl: './bra-input.component.html',
  styleUrls: ['./bra-input.component.css']
})
export class BraInputComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  placeholder: string;

  @Input() value: any;
  @Output() valueChange = new EventEmitter();
  change(newValue) {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }

  @Input()
  readonly: boolean;

  @Input()
  messageError: string;

  @Input()
  maxlength: number;
  
  constructor() { }

  ngOnInit() {
    if(this.maxlength == null){
      this.maxlength = 255;
    }

  }

}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-input/bra-input.component.ts